module.exports = __webpack_public_path__ + "img/DAVID_CANNON_26-rs.39dafa91.jpg";